import { ClickType, GetClickType } from './model';

export const getClickType: GetClickType = ({ link, productType, articleUrl, clickType }) => {
  const outlinkServicePathname = '/outlink';
  // Check if link is internal
  try {
    const linkUrl = new URL(link);

    if (articleUrl.includes(linkUrl.hostname)) {
      if (linkUrl.pathname === outlinkServicePathname) {
        return ClickType.RETAILER;
      }

      return ClickType.INTERNAL;
    }
  } catch (_) {
    if (link.startsWith('/')) {
      return ClickType.INTERNAL;
    }
  }

  if (productType === 200) {
    return ClickType.CHECK_RETAILER;
  }

  if (clickType) {
    return clickType;
  }

  return ClickType.RETAILER;
};
